module.exports = __webpack_public_path__ + "img/2023-Ham-Promo-250.235262d8.jpg";